// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3XV5c","title":"AfterBackImages_title__1rFG5","images":"AfterBackImages_images__mqe-n"};